import { render } from "./AppNav.vue?vue&type=template&id=653ddcb1&scoped=true"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"

import "./AppNav.vue?vue&type=style&index=0&id=653ddcb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653ddcb1"]])

export default __exports__